module.exports = __webpack_public_path__ + "img/18.bbe7f7c2.jpg";